import { render, staticRenderFns } from "./AccordionToTab.vue?vue&type=template&id=34d300b6&scoped=true"
import script from "./AccordionToTab.js?vue&type=script&lang=js&external"
export * from "./AccordionToTab.js?vue&type=script&lang=js&external"
import style0 from "./AccordionToTab.scss?vue&type=style&index=0&id=34d300b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d300b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotIcon: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default,HotImage: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotButton: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
